import logo from '../../../assets/images/TheCleanWheels-version-5.png';
import { useContext } from "react";
import { useNavigate } from 'react-router-dom';
import GlobalContext from "../../../context/GlobalContext";
const Header = (props) => {

	let navigate = useNavigate();
    var globalData=useContext(GlobalContext)

	function logout(){
		globalData.set_token("")
		globalData.set_first_name("")
		globalData.set_last_name("")
		globalData.set_email("")
		globalData.set_phone("")
		globalData.set_image("")
		globalData.set_is_logged_in("")

		sessionStorage.removeItem('token')
		sessionStorage.removeItem('first_name')
		sessionStorage.removeItem('last_name')
		sessionStorage.removeItem('email')
		sessionStorage.removeItem('phone')
		sessionStorage.removeItem('image')
		sessionStorage.removeItem('is_logged_in')

		navigate('/login')
    }

    return (
	
    <header class="header">
		<div class="dashboard_logoarea text-center">
			<a href="" class="menu_bar"><i class="fa fa-bars" aria-hidden="true"></i></a>
			<a href=""><img src={logo} alt="" /></a>
		</div>
		<div class="right_loggedarea">
			<ul>
				<li><a class="log-out" href="" onClick={logout}><i class="fa fa-power-off" aria-hidden="true"></i>Logout</a></li>
				{/* <li><a href="#">My Notifications <span class="notification_count">2</span></a></li>
				<li class="dropdown">
					<a href="#" class="dropdown-toggle" role="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><img src="images/user_image.png" alt="" />My Account
						<i class="fa fa-sort-desc" aria-hidden="true"></i>
					</a>
					<div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
					    <a class="dropdown-item" href="my_profile.html"><i class="fa fa-user" aria-hidden="true"></i>My Profile</a>
					    <a class="dropdown-item" href="edit_profile.html"><i class="fa fa-edit" aria-hidden="true"></i>Edit Profile</a>
					    <a class="dropdown-item" href="login.html"><i class="fa fa-power-off" aria-hidden="true"></i>Logout</a>
					</div>
				</li> */}
			</ul>
		</div>
	</header>
    );
};
export default Header;
	